var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 1.25A1.75 1.75 0 0 0 1.25 3v6c0 .966.784 1.75 1.75 1.75h.778a.75.75 0 0 0 0-1.5H3A.25.25 0 0 1 2.75 9V3A.25.25 0 0 1 3 2.75h6a.25.25 0 0 1 .25.25v.778a.75.75 0 0 0 1.5 0V3A1.75 1.75 0 0 0 9 1.25H3zm4 4A1.75 1.75 0 0 0 5.25 7v6c0 .966.784 1.75 1.75 1.75h6A1.75 1.75 0 0 0 14.75 13V7A1.75 1.75 0 0 0 13 5.25H7zM6.75 7A.25.25 0 0 1 7 6.75h6a.25.25 0 0 1 .25.25v6a.25.25 0 0 1-.25.25H7a.25.25 0 0 1-.25-.25V7z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export default ForwardRef;